import {
    ROLE_ANALYST_ADMIN
} from 'src/components/constants';

import {
    ROUTE_PATH_ADMIN_DASHBOARD,
    ROUTE_PATH_ADMIN_OWN_COMPANY_THIRD_PARTIES,
    ROUTE_PATH_ADMIN_THIRD_PARTIES,
    ROUTE_PATH_ADMIN_USER_MANUAL,
    ROUTE_PATH_ADMIN_QUESTIONNAIRES,
    ROUTE_PATH_ADMIN_QUESTIONNAIRE_DESIGNER,
    ROUTE_PATH_ADMIN_KEYWORD_MANAGEMENT,
    ROUTE_PATH_ADMIN_LICENSE_MANAGEMENT,
    ROUTE_PATH_ADMIN_COMPLIANCE_MONITORING_DASHBOARD,
    ROUTE_PATH_ADMIN_COMPLIANCE_MONITORING_ALERT_DETAIL_PAGE,
    ROUTE_PATH_ADMIN_NEW_COMPLIANCE_QUERY,
    ROUTE_PATH_ADMIN_COMPLIANCE_SCREENING_DASHBOARD,
    ROUTE_PATH_ADMIN_COMPLIANCE_SCREENING_RESULT_DETAIL_PAGE,
    ROUTE_PATH_ADMIN_COMPLIANCE_QUERY_DETAILS,
    ROUTE_PATH_ADMIN_PPWR_DASHBOARD,
    ROUTE_PATH_ADMIN_EUDR_DASHBOARD,
    
    ROUTE_PATH_ADMIN_GUARD_CARRIERS_DASHBOARD,
    ROUTE_PATH_ADMIN_GUARD_FREIGHT_DETAILS,
    ROUTE_PATH_ADMIN_GUARD_BID_VERIFICATION_FLOW,
    ROUTE_PATH_ADMIN_GUARD_BID_SUMMARY,
    ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST,
    ROUTE_PATH_ADMIN_GUARD_CARRIERS_LIST,
    ROUTE_PATH_ADMIN_GUARD_CARRIER_CREATE,
    ROUTE_PATH_ADMIN_GUARD_CARRIER_DETAILS,
    ROUTE_PATH_ADMIN_GUARD_MONITORING_DASHBOARD,
} from '../constants'

import VerticalLayout from '../../../components/VerticalLayout';
import Manager from '../pages/admin/manager';
import SupplierDetails from '../pages/admin/suppliers/details'
import dashboard from '../pages/admin/dashboard';
import NewThirdParty from "../pages/admin/suppliers/new";
import NewThirdPartyAiCreate from "../pages/admin/suppliers/ai-create";
import AIOnboardingPage from "../pages/admin/suppliers/ai-onboarding";
import KanbanBoard from '../pages/admin/kanban-board';
import SupplierTaskDetailsPage from '../pages/admin/suppliers/tasks/details';
import SupplierRiskDetailsPage from '../pages/admin/suppliers/risks/details';
import Settings from '../pages/admin/administration/settings';
import Customization from '../pages/admin/administration/customization/Customization';
import TPDDQuestionnaires from '../pages/admin/administration/questionnaire';
import TPDDQuestionnaireDesigner from '../pages/admin/administration/questionnaire/designer';
import Documents from '../pages/admin/administration/documents';
import ViewDocuments from '../pages/admin/documents';
import UserManual from '../pages/UserManual';
import ListUsers from 'src/pages/Admin/administration/user-management/ListUsers';
import NewUser from 'src/pages/Admin/administration/user-management/new-user';
import EditUser from 'src/pages/Admin/administration/user-management/EditUser';
import HistoryLogs from '../pages/admin/administration/history';
import KeywordManagement from '../pages/admin/administration/keyword-management';
import Products from '../pages/admin/products';
import LicenseManagement from '../pages/admin/administration/license-management';
import ComplianceMonitoringDashboard from '../pages/admin/compliance/monitoring/dashboard';
import AlertDetailPage from '../pages/admin/compliance/monitoring/pages/alert-detail';
import NewComplianceQuery from '../pages/admin/compliance/queries/new';
import ComplianceQueryDetails from '../pages/admin/compliance/queries/details';
import ComplianceScreeningDashboard from '../pages/admin/compliance/screening/dashboard';
import ResultDetailPage from '../pages/admin/compliance/screening/pages/result-detail';


import GuardCarriersDashboard from '../pages/admin/carrier-guard/dashboard';
import GuardFreightsList from '../pages/admin/carrier-guard/freights';
import GuardFreightDetails from '../pages/admin/carrier-guard/freights/details';
import GuardBidSummary from '../pages/admin/carrier-guard/freights/details/bids';
import GuardBidVerificationFlow from '../pages/admin/carrier-guard/freights/details/bids/flow';
import GuardCarriersList from '../pages/admin/carrier-guard/carriers';
import GuardCarrierCreate from '../pages/admin/carrier-guard/carriers/create';
import GuardCarrierDetails from '../pages/admin/carrier-guard/carriers/details';
import GuardMonitoringDashboard from '../pages/admin/carrier-guard/monitoring';

import { Redirect } from 'react-router-dom';

const RedirectToPpwrDashboardTab = () => (
    <Redirect to={`${ROUTE_PATH_ADMIN_DASHBOARD}?tab=ppwr`} />
);

const RedirectToEudrDashboardTab = () => (
    <Redirect to={`${ROUTE_PATH_ADMIN_DASHBOARD}?tab=eudr`} />
);

const adminRoutes = [
    /**
     * Carrier Guard routes
     */
    {
        path: ROUTE_PATH_ADMIN_GUARD_CARRIERS_DASHBOARD,
        component: GuardCarriersDashboard,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_BID_VERIFICATION_FLOW,
        component: GuardBidVerificationFlow,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_BID_SUMMARY,
        component: GuardBidSummary,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_FREIGHT_DETAILS,
        component: GuardFreightDetails,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST,
        component: GuardFreightsList,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_CARRIER_DETAILS,
        component: GuardCarrierDetails,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_CARRIERS_LIST,
        component: GuardCarriersList,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_CARRIER_CREATE,
        component: GuardCarrierCreate,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_GUARD_MONITORING_DASHBOARD,
        component: GuardMonitoringDashboard,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    /**
     * Third Party Management routes
     */
    {
        path: ROUTE_PATH_ADMIN_DASHBOARD,
        component: dashboard,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_PPWR_DASHBOARD,
        component: RedirectToPpwrDashboardTab,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_EUDR_DASHBOARD,
        component: RedirectToEudrDashboardTab,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_USER_MANUAL,
        component: UserManual,
        layout: VerticalLayout,
        type: 'admin',
        modules: ["tp"],
    },
    {
        path: '/admin/3rd-party/suppliers/:id/details',
        component: SupplierDetails,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/suppliers/ai-create',
        component: NewThirdPartyAiCreate,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/suppliers/create',
        component: NewThirdParty,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/suppliers/ai-onboarding',
        component: AIOnboardingPage,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/suppliers/:supplierId/tasks/:taskId/details',
        component: SupplierTaskDetailsPage,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/suppliers/:supplierId/risks/:riskId/details',
        component: SupplierRiskDetailsPage,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_OWN_COMPANY_THIRD_PARTIES,
        component: () => <Manager suppliersType={'own'} />,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_THIRD_PARTIES,
        component: () => <Manager suppliersType={'all'} />,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/kanban-board',
        component: KanbanBoard,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/products',
        component: Products,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/documents',
        component: ViewDocuments,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_COMPLIANCE_MONITORING_ALERT_DETAIL_PAGE,
        component: AlertDetailPage,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },   
    {
        path: ROUTE_PATH_ADMIN_COMPLIANCE_MONITORING_DASHBOARD,
        component: ComplianceMonitoringDashboard,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_COMPLIANCE_SCREENING_RESULT_DETAIL_PAGE,
        component: ResultDetailPage,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_COMPLIANCE_SCREENING_DASHBOARD,
        component: ComplianceScreeningDashboard,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_NEW_COMPLIANCE_QUERY,
        component: NewComplianceQuery,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    }, 
    {
        path: ROUTE_PATH_ADMIN_COMPLIANCE_QUERY_DETAILS,
        component: ComplianceQueryDetails,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    }, 
    {
        path: '/admin/3rd-party/administration/settings',
        component: Settings,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_LICENSE_MANAGEMENT,
        component: LicenseManagement,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/administration/users/:id/edit',
        component: EditUser,
        layout: VerticalLayout,
        type: 'admin',
        roles: [ROLE_ANALYST_ADMIN],
        modules: ["tp"],
    },
    {
        path: '/admin/3rd-party/administration/users/add',
        component: NewUser,
        layout: VerticalLayout,
        type: "admin",
        roles: [ROLE_ANALYST_ADMIN],
        modules: ["tp"]
    },
    {
        path: '/admin/3rd-party/administration/users',
        component: ListUsers,
        layout: VerticalLayout,
        type: "admin",
        roles: [ROLE_ANALYST_ADMIN],
        modules: ["tp"]
    },
    {
        path: '/admin/3rd-party/administration/customization',
        component: Customization,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_KEYWORD_MANAGEMENT,
        component: KeywordManagement,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_QUESTIONNAIRE_DESIGNER,
        component: TPDDQuestionnaireDesigner,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: ROUTE_PATH_ADMIN_QUESTIONNAIRES,
        component: TPDDQuestionnaires,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/administration/documents',
        component: Documents,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    },
    {
        path: '/admin/3rd-party/administration/history-logs',
        component: HistoryLogs,
        layout: VerticalLayout,
        type: 'admin',
        modules: ['tp']
    }
];

export default adminRoutes;

export {
    adminRoutes
};